/** angular */
import { Injectable } from '@angular/core';
import { BydLocalStorage } from '@sixense/ds-lib-utils';
/** end angular */

/** sixense */
import { BydUserAccount } from '@sixense/byd-auth-service';
/** end sixense */

/** constants */
import { LATEST_PROJECT_ID, LATEST_ACCOUNT_ID } from './constants/local-storage.constant';
/** end constants */

@Injectable({ providedIn: 'root' })
export class AuthService {
  /**
   * Get user account Id from local Storage.
   *
   * @returns number
   */
  get accountId(): number {
    return this.account?.account_id;
  }

  /**
   * Get user account email from local Storage.
   *
   * @returns number
   */
  get accountEmail(): string {
    return this.account?.account_email;
  }

  /**
   * Get the latest used account id through local storage.
   *
   * @returns number
   */
  get latestAccountId(): number {
    return BydLocalStorage.getParsedItem(LATEST_ACCOUNT_ID);
  }

  /**
   * Get the latest consulted project id through local storage.
   *
   * @returns number
   */
  getLatestProjectId(): number {
    return BydLocalStorage.getParsedItem(LATEST_PROJECT_ID);
  }

  /**
   * Set the latest consulted project id to local storage.
   *
   * @param projectId The project id
   */
  setLatestProjectId(projectId: number): void {
    BydLocalStorage.setItem(LATEST_PROJECT_ID, `${projectId}`);
  }

  /**
   * Update latest local stored account informations.
   */
  updateLatestAccount(): void {
    if (this.notSameUser) {
      this.setLatestAccountId();
      this.resetLatestProjectId();
    }
  }

  /**
   * Reset the latest consulted project id on local storage.
   */
  private resetLatestProjectId(): void {
    BydLocalStorage.removeItem(LATEST_PROJECT_ID);
  }

  /**
   * Set the latest used account id to local storage.
   */
  private setLatestAccountId(): void {
    BydLocalStorage.setItem(LATEST_ACCOUNT_ID, `${this.accountId}`);
  }

  /**
   * Get user account in local storage.
   *
   * @returns currentAccount
   */
  private get account(): BydUserAccount {
    return BydLocalStorage.getParsedItem<BydUserAccount>('currentAccount');
  }

  /**
   * Check if the user was changed from the last connection.
   *
   * @returns boolean
   */
  private get notSameUser(): boolean {
    return this.accountId !== this.latestAccountId;
  }
}
